import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Lock, Headset, MailCheck, ArrowRight } from "lucide-react";

const points = [
  { icon: <Lock size={20} />, title: "Private & exclusive", desc: "Our own pool — no public onlookers, no crowds." },
  { icon: <Headset size={20} />, title: "Reception team on hand", desc: "A friendly team at the centre during lesson times." },
  { icon: <MailCheck size={20} />, title: "Fast, friendly replies", desc: "Quick answers to your emails and queries." },
];

export default function StandOut() {
  return (
    <section className="py-16 md:py-24" data-testid="home-standout">
      <div className="container mx-auto px-6 md:px-12">
        <div className="relative overflow-hidden bg-[#0A2540] rounded-[2.5rem] p-8 md:p-14 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="blob absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#0EA5E9]/20" aria-hidden="true" />
          <div className="relative">
            <span className="text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">The Happy Tiddlers difference</span>
            <h2 className="mt-4 font-heading text-3xl md:text-4xl font-bold tracking-tight text-white leading-tight">
              More than a lesson — you're properly looked after
            </h2>
            <p className="mt-5 text-lg text-[#CBD5E1] leading-relaxed">
              At most swim schools, once lessons start you're on your own — no one to turn to once you leave the poolside. We're different: a private centre with a friendly team on hand before, during and after every session, and we're quick to reply whenever you need us.
            </p>
            <Link
              to="/how-it-works"
              className="group mt-7 inline-flex items-center gap-2 font-bold text-[#38BDF8] hover:gap-3 transition-all"
              data-testid="standout-link"
            >
              See what to expect
              <ArrowRight size={18} className="group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </div>

          <div className="relative space-y-5">
            {points.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, x: 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-start gap-4 bg-white/5 border border-white/10 rounded-2xl p-5"
                data-testid={`standout-point-${i}`}
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#FF7A1A] text-white shrink-0">
                  {p.icon}
                </span>
                <div>
                  <h3 className="font-heading text-lg font-bold text-white leading-tight">{p.title}</h3>
                  <p className="mt-1 text-[#CBD5E1] leading-relaxed">{p.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
